import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import { RootState, useAppDispatch } from '@/store';
import { getReportCsvUrl } from '@/store/report-csv/action';
import './index.css'
import {
  ReactComponent as RiDownloadLine
} from "@/assets/icons/ri-download-line.svg";
import {getLongDateFormat} from "@/utils";

interface ReportResultLayoutProps {
  children?: JSX.Element
  handleDownload?: () => void
  useHeaderVenue: boolean
  additionalHeaderTitle?: string
  useHeaderDate: boolean,
  overrideHeader?: string
  isVenueReport?: boolean
  reportType?: string
  selectedInsightType?: string
}

const ReportResultLayout:
  React.FC<ReportResultLayoutProps> =
  ({
     children,
     handleDownload,
     useHeaderVenue = true,
     useHeaderDate = true,
     additionalHeaderTitle,
     overrideHeader,
     isVenueReport = false  ,
     reportType = '',
     selectedInsightType = ''
   }) => {
    const [filters] = useSearchParams()
    const startDate = parseInt(filters.get('startDate'), 10)
    const endDate = parseInt(filters.get('endDate'), 10)
    const headerDate = `${getLongDateFormat(startDate)} - ${getLongDateFormat(endDate)}`
    const venueId = filters.get('venueId')
    const venues = useSelector((state: RootState) =>
      state.userInfo.state.venues)
    const headerTitle = venues.find(v => v.id === venueId)?.name ?? ''
    const dispatch = useAppDispatch()

    const downloadReportUrl = ({ type, reportStartDate, reportEndDate, insightType }) => {
      dispatch(getReportCsvUrl({ type, reportStartDate, reportEndDate, insightType, venueId })).then((res: { [key: string]: any }) => {
        if (!res.error) {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(new Blob([res.payload.data], { type: 'text/csv' }));
          link.download = 'report.csv';
          link.dispatchEvent(new MouseEvent('click'));
          URL.revokeObjectURL(link.href);
        }
      })
    }

    const handleClickDownload = () => {
      if (handleDownload) {
        handleDownload()
        return
      }
      downloadReportUrl({ type: reportType, reportStartDate: startDate, reportEndDate: endDate, insightType: selectedInsightType })
    }

    return (
      <div className="card p-7 j-col">
        <div className="j-col">
          <div className="j-row justify-between">
            <div className="text-jlg font-bold">Result</div>
            <div className="flex">
              <button
                onClick={handleClickDownload}
                className="cursor-pointer text-black-primary text-jsm font-medium flex gap-2 justify-center items-center py-2 px-6 rounded border border-stroke-subtle">
                <RiDownloadLine/>
                Download
              </button>
            </div>
          </div>
          <div className="j-col gap-2">
            {
              useHeaderVenue && <div
                className="text-j2xl font-bold">{overrideHeader ?? headerTitle}</div>
            }
            {
              (overrideHeader && isVenueReport) &&
              <div className="text-jlg font-medium">{headerTitle}</div>
            }
            {additionalHeaderTitle &&
              <div className="text-lg font-medium">
                {additionalHeaderTitle}
              </div>}
            {
              useHeaderDate &&
              <div className="text-base text-grey-dark font-medium">
                {headerDate}
              </div>
            }
          </div>
        </div>
        <div className="horizontal-separator my-6"/>
        {children}
      </div>
    )
  }
export default ReportResultLayout;
